import React from "react"
import { Grid, Typography } from "@material-ui/core"
import PlusCircleIcon from "../../../assets/images/icon/PlusCircleIcon"
import FunnelIcon from "../../../assets/images/icon/FunnelIcon"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import usePlatform from "../../../hooks/usePlatform"
import { useTrack } from "@hackler/react-sdk"
import { FormattedMessage } from "react-intl"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    newFeature: {
      position: "relative",
      height: (lang) => lang === "ko" ? 133 : 157,
      marginTop: 10,
      paddingTop: 15,
      background: "#F4F7FF",
      border: "1px solid rgba(5, 26, 82, 0.1)",
      borderRadius: 20,
      textAlign: "center",
      "& h5": {
        fontSize: 20,
      },
      [theme.breakpoints.up("md")]: {
        marginTop: 37,
        height: 148,
        paddingTop: 25,
        "& h5": {
          fontSize: 24,
        },
      },
    },
    newFeatureEmphasis: {
      marginRight: 12,
      color: theme.palette.primary.main,
      "& svg": {
        marginRight: 4,
      },
      "& svg:not(:first-child)": {
        marginLeft: 12,
      },
    },
    plusIcon: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      top: -16,
      [theme.breakpoints.up("md")]: {
        top: -23,
      },
    },
    bottom: {
      width: 372,
      padding: "18px 10px 0px",
      [theme.breakpoints.up("md")]: {
        width: 1186,
      },
    },
    caption: {
      marginTop: 24,
      opacity: 0.3,
      fontSize: 12,
      textAlign: "center",
      [theme.breakpoints.up("md")]: {
        fontSize: 14,
        textAlign: "right",
      },
    }
  })
)

export default function CommonBenefit() {
  const lang = Locale.getLangCode()
  const classes = useStyles({ lang })
  const track = useTrack()
  const { isMobile } = usePlatform()

  return (
    <Grid className={classes.bottom}>
      <Grid item xs={12} container justify={"center"} alignItems={"center"} className={classes.newFeature}>
        <Grid className={classes.plusIcon}>
          <PlusCircleIcon isMobile={isMobile} />
        </Grid>
        <Grid item xs={12} style={lang === "en" && isMobile ? { marginBottom: 16 } : {}}>
          <Typography variant={"h5"}>
            {isMobile ? (
              <strong>
                <span className={classes.newFeatureEmphasis} style={lang === "en" ? { marginRight: 0 } : {}}><FormattedMessage id={"funnel"} /></span>
                { lang === "en" && <br /> }
                <FormattedMessage id={"free_charge"} />
              </strong>
            ) : (
              <strong>
                <span className={classes.newFeatureEmphasis}>
                  <FunnelIcon isMobile={true} />
                  <FormattedMessage id={"funnel"} />
                </span>
                <FormattedMessage id={"free_charge"} />
              </strong>
            )}
          </Typography>
        </Grid>
        {isMobile ? (
          <Typography style={{ fontSize: 14, marginTop: "-40px", opacity: 0.6 }}>
            <FormattedMessage id={"funnel_promotion_1"} /> <br />
              <FormattedMessage id={"funnel_promotion_2"} />
          </Typography>
        ) : (
          <Typography style={{ fontSize: 20, marginTop: "-40px", opacity: 0.6 }}>
            <FormattedMessage id={"funnel_promotion_1"} /> <FormattedMessage id={"funnel_promotion_2"} />
          </Typography>
        )}
      </Grid>
      <Grid container item xs={12} justify={isMobile ? "center" : "flex-end"}>
      </Grid>
      <Grid container item xs={12} justify={isMobile ? "center" : "flex-end"}>
        <Typography variant={"body2"} className={classes.caption}>
          <FormattedMessage id={"plan_tax_desc"} />
        </Typography>
      </Grid>
    </Grid>
  )
}
